<template>
  <div class="modal fade" id="DriversLicenseModal" tabindex="-1" aria-labelledby="DriversLicenseModalLabel" aria-hidden="true" @keydown.esc="clearForm">
    <div class="modal-dialog">
      <div class="modal-content" v-if="!this.loader">
        <div class="modal-header p-5">
          <h5 class="modal-title" id="DriversLicenseModalLabel" v-html="'Водительское удостоверение'"></h5>
          <button type="button" @click="clearForm" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body p-5">
            <div class="row">
              <div class="col-12">
                <input-field
                    v-model="document.number"
                    @change="getDriverLicense"
                    :required="true"
                    id="document.number"
                    name="document.number"
                    placeholder="Номер документа"
                    type="text"
                    mb="5"
                />
                <date-field
                    v-model="document.issued"
                    :required="true"
                    id="document.issued"
                    name="data.document.issued"
                    placeholder="Дата выдачи"
                    mb="5"
                />
              </div>
              <div v-if="issuedErr" id="document.issued" class="text-danger mt-2 mb-2">
                Дата выдачи не может быть больше текущей.
              </div>
            </div>
        </div>
        <div class="modal-footer p-3 justify-content-between">
          <div
              class="btn btn-sm btn-secondary"
              data-bs-dismiss="modal"
              @click="clearForm"
          >Закрыть</div>
          <button
              :disabled="!valid"
              @click="addDriversLicense"
              type="submit"
              class="btn btn-sm btn-primary"
              v-html="'Добавить'">
          </button>
        </div>
      </div>
      <div v-else class="modal-content">
        <loader-full style="height: 400px"/>
      </div>
    </div>
  </div>
</template>

<script>
// Field
import LoaderFull from '@/components/Main/LoaderFull'
import InputField from '@/components/Fields/InputField'
import DateField  from '@/components/Fields/DateField'
import {notify}   from '@kyvg/vue3-notification'
import axios from "axios";

export default {
  name: 'DriversLicenseModal',
  components: {
    LoaderFull,
    InputField,
    DateField,
  },
  emits: ['addDriversLicense'],
  props: {
    hash: {
      type: Number,
      default: null
    },
    documentNumber: {
      type: String,
      default: null
    },
    resident: {
      type: Boolean,
      default: false
    },
    iin: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      document: {
        number: null,
        issued: null
      },
      user:     null,
      valid:    false,
      loader:   false,
      issuedErr: false
    }
  },
  mounted() {
  },
  methods: {
    clearForm() {
      this.document = {
        number: null,
        issued: null
      }
      this.user = null
      this.valid = false
      this.issuedErr = false
    },
    getDriverLicense() {
      console.log(this.iin, this.document.number)
      if (this.iin && this.document.number && this.resident) {
        this.loader = true
        axios.post('/api/client/get-driver-license', {iin: this.iin, number: this.document.number})
            .then(res => {
              if (res.data.result) {
                this.document.issued = res.data.data.issued;
                this.document.number = res.data.data.number;
                this.addDriversLicense()
              } else {
                notify({
                  duration: 7000,
                  type: 'error',
                  speed: 1000,
                  title: 'Ошибка',
                  text: 'Документ по номеру '+this.document.number+' не найдено.',
                })
              }
            })
            .catch(err => {
              notify({
                duration: 7000,
                type: 'error',
                speed: 1000,
                title: 'Ошибка',
                text: err.message,
              })
            })
            .finally(() => {this.loader = false})
      }
    },
    addDriversLicense() {
      this.$emit('addDriversLicense', this.document, this.documentNumber)
    },
  },
  watch: {
    hash: {
      immediate: true,
      handler() {
        this.clearForm()
      }
    },
    document: {
      deep: true,
      handler() {
        this.issuedErr = new Date(this.document.issued) > new Date();
        this.valid = !!(this.document.number && this.document.issued && !this.issuedErr);
      }
    },
  }
}
</script>

<style scoped></style>
